export const RUSSIAN = 'ru'
export const SPANISH = 'es'
export const FRENCH = 'fr'
